module.exports = __webpack_public_path__ + "assets/img/device.78954d93.png";